import T from 'prop-types'
import React from 'react'

import BEMHelper from '../../helpers/bem'
import Button from '../Button'
import styles from './Styles.module.scss'

const bem = new BEMHelper(styles)

export default function Cover({ title, preamble, promotedLesson, illustration, introduction }) {
  const action = {
    label: 'Introduksjon',
    href: `/undervisningsopplegg/${promotedLesson?.slug}`,
  }

  const showPromotedLesson = !introduction && promotedLesson

  return (
    <header {...bem('')} id="cover">
      <div {...bem('content')}>
        <h1 {...bem('title')}>{title}</h1>

        {preamble && <p {...bem('preamble')}>{preamble}</p>}
        {showPromotedLesson && <Button large primary {...action} />}
      </div>

      {illustration?.path && (
        <div {...bem('illustration')}>
          <div {...bem('image')}>
            <picture>
              {illustration.webp && <source srcSet={illustration.webp} type="image/webp" />}
              <source srcSet={illustration.path} type="image/png" />
              <img src={illustration.path} alt="" width={800} height={800 / illustration.aspect} />
            </picture>
          </div>
        </div>
      )}
    </header>
  )
}

Cover.propTypes = {
  title: T.string.isRequired,
  preamble: T.string,
  illustration: T.shape({
    path: T.string.isRequired,
    aspect: T.number.isRequired,
  }),
  promotedLesson: T.object,
  introduction: T.object,
}
